import React, { useEffect, useState } from 'react'
import BaseContainer from '../BaseContainer/index'
import IconComponent from "../icons"
import H3 from '../Headings/H3'
import BaseButton from "../BaseButton"
import { pureKeys } from "../../utils/helpers"
import ExploreNetworkHeader from "./ExploreNetworkHeader"

const LOAD_MORE = 3

export default function ExploreNetworkComp({ data }) {
  let count = 0
  const [itemVisible, setItemVisible] = useState(LOAD_MORE)

  const { airNetworkRoutes = [], loadMore, header, textLabel, allCategories=[] } = data;
  let {defaultCategory= 'Featured'} = data;
  const [selectedDropdown, setSelectedDropdown] = useState('')

  useEffect(()=>{
    const checkReload = () => {
      const navigationEntries = performance.getEntriesByType('navigation');
      if(navigationEntries.length>0 && navigationEntries[0].type === 'reload'){
        sessionStorage.clear();
        setSelectedDropdown(defaultCategory);
      } else {
        sessionStorage.getItem("loadMoreCount") && setItemVisible(parseInt(sessionStorage.getItem("loadMoreCount")));
        const networkCategory = sessionStorage.getItem("networkCategory");
        setSelectedDropdown(networkCategory)
      }
    }
    checkReload();
  },[defaultCategory])

  useEffect(() => {
    allCategories.length > 0 && allCategories.forEach(item => {
      // set Selected option
        const dropdownValue = (selectedDropdown==='')?defaultCategory:selectedDropdown;
      if (item.value === dropdownValue) {
        sessionStorage.setItem("networkCategory",item.value);
        setSelectedDropdown(item);
      }
    })
  }, [allCategories, defaultCategory, selectedDropdown])

  const handleLoadMore = () => {
    const visibleCount = itemVisible + LOAD_MORE;
    sessionStorage.setItem("loadMoreCount",visibleCount);
    setItemVisible(visibleCount)
  }

  function ScheduleLink({ item }) {
    return <>
      {item.linkScheduleTitle && <BaseButton title={item.linkScheduleTitle} href={item.linkScheduleHref} target={item.linkScheduleTarget} type="secondary" size="large" className="lg:mt-4 text-center w-full lg:w-auto lg:text-base px-5 py-2 lg:h-[50px] font-bold lg:mr-3" />}
      {item.linkEnquiryTitle && <BaseButton title={item.linkEnquiryTitle} href={item.linkEnquiryHref} target={item.linkEnquiryTarget} type="tertiary" size="none" className="lg:mt-4 text-center w-full lg:w-auto mt-4" />}
    </>
  }

  function Routes({ routes }) {
    const { inboundAirport1, inboundAirport2, inboundTime1, inboundTime2, outboundAirport1, outboundAirport2, outboundTime1, outboundTime2 } = routes
    return (
      <>
        <div className={`flex items-start p-0`}>
        {inboundAirport1 && <div className='w-10'>
            <h6 className="text-transparent bg-clip-text bg-gradient-to-t from-ek-red to-ek-red-300 font-Heroic-Medium text-[32px] italic whitespace-nowrap py-1 pr-3">{inboundAirport1}</h6>
            <span className="text-xs">{inboundTime1}</span>
          </div>}
          {inboundAirport1 && outboundAirport1 && <div className="relative flex-grow before:h-0.5 before:w-[80%] before:absolute before:bg-ek-grey-400 before:left-2 before:top-[49.5%] before:-translate-y-px flex justify-center"><IconComponent icon={`plane`} className={`fill-ek-neutral-grey-500 z-10`} /></div>}
          {outboundAirport1 && <div>
            <h6 className="text-transparent bg-clip-text bg-gradient-to-t from-ek-red to-ek-red-300 font-Heroic-Medium text-[32px] italic whitespace-nowrap py-1 pr-3">{outboundAirport1}</h6>
            <span className="text-xs">{outboundTime1}</span>
          </div>}
        </div>
        <div className={`flex items-start p-0 my-4 lg:mt-10`}>
          {inboundAirport2 && <div className='w-10'>
            <h6 className="text-transparent bg-clip-text bg-gradient-to-t from-ek-red to-ek-red-300 font-Heroic-Medium text-[32px] italic whitespace-nowrap py-1 pr-3">{inboundAirport2}</h6>
            <span className="text-xs">{inboundTime2}</span>
          </div>}
          {inboundAirport2 && outboundAirport2 && <div className="relative flex-grow before:h-0.5 before:w-[80%] before:absolute before:bg-ek-grey-400 before:left-2 before:top-[49.5%] before:-translate-y-px flex justify-center"><IconComponent icon={`plane`} className={`fill-ek-neutral-grey-500 z-10`} /></div>}
          {outboundAirport2 &&
          <div>
            <h6 className="text-transparent bg-clip-text bg-gradient-to-t from-ek-red to-ek-red-300 font-Heroic-Medium text-[32px] italic whitespace-nowrap py-1 pr-3">{outboundAirport2}</h6>
            <span className="text-xs">{outboundTime2}</span>
          </div>}
        </div>
      </>
    )
  }

  return (
    <BaseContainer className="mt-[40px] lg:mt-[80px] mb-[40px] lg:mb-[80px] bg-ek-neutral-grey">
      <ExploreNetworkHeader
        title={header}
        filterLabel={textLabel}
        selectedDropdown={selectedDropdown}
        setSelectedDropdown={setSelectedDropdown}
        dropdownOptions={allCategories}
        setItemVisible={setItemVisible}
        defaultVisible={itemVisible}
      />
      {
        airNetworkRoutes.map((item, i) => {
          const { title = '', description, imageDesktop, imageMobile, inboundAirport1, inboundAirport2, inboundTime1, inboundTime2, outboundAirport1, outboundAirport2, outboundTime1, outboundTime2 } = item
          const routes = {
            inboundAirport1, inboundAirport2, inboundTime1, inboundTime2, outboundAirport1, outboundAirport2, outboundTime1, outboundTime2
          }
          if (count <= itemVisible && selectedDropdown?.value === item.category) {
            count++
          }
          return count <= itemVisible && selectedDropdown?.value === item.category && <section className="mt-4 lg:mt-8 bg-white rounded-lg border border-ek-neutral-grey-300 p-5 flex lg:items-center flex-col lg:flex-row" key={pureKeys(title)}>
            <div className="col-span-4 lg:w-[284px] lg:h-[309px] lg:flex-shrink-0 lg:self-start">
              {(imageDesktop || imageMobile) && <picture>
                <source media="(max-width:1023px)" srcSet={imageMobile} />
                <source media="(min-width:1024px)" srcSet={imageDesktop} />
                <img src={imageDesktop} alt={title} loading="lazy" width={284} height={209} className="rounded-lg w-full h-full object-cover" />
              </picture>}
            </div>
            <div className='flex flex-col mt-4 lg:mt-0 lg:ml-5 xl:ml-10'>
              <div className='flex flex-col lg:flex-row'>
                <div className='lg:flex-[3]'>
                  {title && <H3 className="mb-4 lg:mb-5">{title}</H3>}
                  <span className="h-0.5 w-[60px] bg-ek-red-300 block mb-4 lg:mb-5"></span>
                  {description && <div className="text-ek-grey-500 lg:text-ek-grey-600" dangerouslySetInnerHTML={{ __html: description }}></div>}
                </div>
                <div className='flex items-center justify-center lg:flex-[2]'>
                  <div className="text-center w-full lg:w-[210px] lg:ml-auto lg:flex-shrink-0 mt-4">
                    <Routes routes={routes} />
                  </div>
                </div>
              </div>
              <div className="flex flex-col lg:flex-row">
                <ScheduleLink item={item}/>
              </div>
            </div>
          </section>
        })
      }
      {/* Load More button */}
      {loadMore && airNetworkRoutes.filter(item => item.category === selectedDropdown.value).length > itemVisible && <div className="flex justify-center"><BaseButton title={loadMore} type="secondary" size="medium" className="mt-4 lg:mt-12 text-center w-full lg:w-auto px-5 py-2 font-bold !border-ek-grey-400" btnClick={handleLoadMore} /></div>}

    </BaseContainer>
  )
}
